<template>
  <div id="training">
    <div class="banner">
      <img src="../../../assets/image/training/banner.png" alt="">
      <div class="bottom">
        <a class="left" href="#form">我要报名</a>
      </div>
    </div>
    <div class="skill">
      <div class="skill_top">
        <div class="skill_box wow bounceIn" data-wow-delay="0.8s">
          <h3>全媒体运营师发布</h3>
          <p>All media operation division</p>
        </div>
      </div>
      <div class="level">
        <div class="level_box wow slideInDown" id="firtstLevel" data-wow-delay="0.2s">
          <img src="@/assets/image/training/01zs.png" alt="">
        </div>
        <div class="level_box wow slideInDown" id="seconedlevel" data-wow-delay="0.4s">
          <img src="@/assets/image/training/02zs.png" alt="">
        </div>
        <div class="level_box wow slideInDown" data-wow-delay="0.6s">
          <img src="@/assets/image/training/03zs.png" alt="">
        </div>
      </div>
    </div>
    <div class="prospect">
      <div class="title">
        <h3>全媒体运营师行业前景</h3>
        <p>Prospects of all media operators</p>
      </div>
      <div class="content">
        <div class="item">
          <p class="title">
            <span class="number">01</span>
            <span>新媒体+短视频红利爆发,平均工资高，高地线上化办公，同时是年轻人发展副业的最佳选择</span>
          </p>
          <div class="center">
            <div class="left cell" style="height: auto; position: relative;">
              <p style="font-size: 24px; font-weight: bold; color: #D4E8FE; position: absolute; top: 166px; left: 0;">职友集</p>
              <div class="wages">
                <span class=blue>￥<span>10.6K</span></span>/月平均工资
              </div>
              <p class="source">数据统计来自近1年4511份样本，截至2021-06-18</p>
              <p class="section">薪酬区间：3K-30K,最多人拿：10K-15K</p>
              <div id="chart2" ></div>
              <p class="source1">说明：北京新媒体运营一个月多少钱？平均工资￥10.6k,其中拿10k-15k工资的占比最多，
                达26.7%，数据统计依赖于各平台发布的公开薪酬，仅供参考。</p>
            </div>
            <div class="right">
              <div class="center" style="height:357px">
                <div class="left" style="position: relative;">
                  <img src="@/assets/image/training/yuan1.png" alt="">
                  <p>73.8%</p>
                </div>
                <div class="right" style="position: relative;">
                  <img src="@/assets/image/training/yuan2.png" alt="">
                  <p>63.3%</p>
                </div>
              </div>
              <p class="bottom">资料来源：Fastdata极数《2019中国网络视听发展研究报告》前瞻行业研究院整理</p>
            </div>
          </div>
        </div>
        <div class="item">
          <p class="title">
            <span class="number">02</span>
            <span>全媒体人才未来10+岗位方向选择</span>
          </p>
          <div class="center1">
            <div class="direction">
              <img src="@/assets/image/training/01yq.png" alt="">
              <p>新媒体运营</p>
            </div>
            <div class="direction">
              <img src="@/assets/image/training/02yq.png" alt="">
              <p>短视频运营</p>
            </div>
            <div class="direction">
              <img src="@/assets/image/training/03yy.png" alt="">
              <p>运营专员</p>
            </div>
            <div class="direction">
              <img src="@/assets/image/training/04yx.png" alt="">
              <p>营销策划</p>
            </div>
            <div class="direction">
              <img src="@/assets/image/training/05sq.png" alt="">
              <p>社群运营</p>
            </div>
            <div class="direction">
              <img src="@/assets/image/training/07wl.png" alt="">
              <p>网络营销</p>
            </div>
            <div class="direction">
              <img src="@/assets/image/training/08zb.png" alt="">
              <p>直播运营</p>
            </div>

            <div class="direction">
              <img src="@/assets/image/training/08zb.png" alt="">
              <p>媒介策划</p>
            </div>
            <div class="direction">
              <img src="@/assets/image/training/08zb.png" alt="">
              <p>活动策划</p>
            </div>
            <div class="direction">
              <img src="@/assets/image/training/08zb.png" alt="">
              <p>广告创意</p>
            </div>
          </div>
        </div>
        <div class="item">
          <p class="title">
            <span class="number">03</span>
            <span>适合人群</span>
          </p>
          <div class="content">
            <div class="item">
              <img src="@/assets/image/training/live_01.png" alt="">
              <p class="title1">自由职业创业者</p>
              <img src="@/assets/image/training/biaotixian_01.png" class="dell" alt="">
              <p class="bottom">
                想要进入短视频领域的小白和企业<br/>
                用新媒体赋能自身，<br/>
                驱动商业变现，拓宽知识边界，<br/>
                拓展新的职业能力<br/>
              </p>
            </div>
            <div class="item">
              <img src="@/assets/image/training/live_02.png" alt="">
              <p class="title1">应届大学毕业生</p>
              <img src="@/assets/image/training/biaotixian_01.png" class="dell" alt="">
              <p class="bottom">
                文科类专业大学生，<br/>
                以及缺乏工作经验和技能，<br/>
                对未来没有明确的规划，期望通过<br/>
                学习新媒体跻身IT行业的人员<br/>
              </p>
            </div>
            <div class="item">
              <img src="@/assets/image/training/live_03.png" alt="">
              <p class="title1">互联网转行人员</p>
              <img src="@/assets/image/training/biaotixian_01.png" class="dell" alt="">
              <p class="bottom">
                在传统行业工作多年想快速转行<br/>
                互联网人员，尤其是从事财务、<br/>
                人事、行政等文职类岗位人员
              </p>
            </div>
            <div class="item">
              <img src="@/assets/image/training/live_04.png" alt="">
              <p class="title1">学历不高、00后人群</p>
              <img src="@/assets/image/training/biaotixian_01.png" class="dell" alt="">
              <p class="bottom">
                思维活跃，不愿意按部就班，<br/>
                喜欢接触新兴事物，<br/>
                对互联网行业有好奇心和探索欲望
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="courses first">
      <div class="courses_top">
        <div class="courses_box wow bounceInDown">
          <h3>课程大纲</h3>
          <p>Course outline</p>
        </div>
      </div>
      <div class="base">
        <div class="base_l wow slideInLeft " id="swiper1" data-wow-delay="0.2s">
          <!-- <div class="base_top">
            <img src="@/assets/image/training/icon_jichu.png" alt="">
            <span>基础版</span>
          </div> -->
            <ul class="title_l">
              <li class="title_p child1 wow slideInLeft" :class="courseActive===1?'title_p_y':''" data-wow-delay="0.2s" @click="courseActive=1">
                <p>全媒体运营师</p>
              </li>
              <li class="title_p child2 wow slideInLeft" :class="courseActive===2?'title_p_y':''" data-wow-delay="0.4s" @click="courseActive=2">
                <p>网络视听主播</p>
              </li>
              <li class="title_p child3 wow slideInLeft" :class="courseActive===3?'title_p_y':''" data-wow-delay="0.6s" @click="courseActive=3">
                <p>直播运营</p>
              </li>
              <li class="title_p child4 wow slideInLeft" :class="courseActive===4?'title_p_y':''" data-wow-delay="0.8s" @click="courseActive=4">
                <p>短视频创作采编</p>
              </li>
              <li class="title_p child5 wow slideInLeft" :class="courseActive===5?'title_p_y':''" data-wow-delay="1s" @click="courseActive=5">
                <p>短视频内容运营</p>
              </li>
            </ul>
        </div>
        <div class="base_r wow bounceIn" data-wow-delay="0.4s">
          <div class="item_none" :class="courseActive===1?'right_show':''">
            <div class="right_box " >
              <div class="box_l " >
                <p class="title"><img src="@/assets/image/training/icon_neirong.png" alt="">主要内容</p>
                <ul class="main_item" v-show="page == 1">
                  <li>法律法规及行业趋势</li>
                  <li>直播间的视觉呈现</li>
                  <li>产品拍摄及预热短视频拍摄</li>
                  <li class="red">主播个人IP打造</li>
                  <li>粉丝运营转化及流量解析</li>
                  <li>直播平台规则解析</li>
                  <li>开播前准备</li>
                  <li class="red">主播间数据分析</li>
                  <li>镜头表现及发声训练</li>
                  <li class="red">主播选品</li>
                  <li>直播脚本撰写</li>
                  <li>从0到1的主播话术</li>
                  <li>主播经验心得分享</li>
                  <li>直播复盘</li>
                  <li>淘宝店铺直播运营</li>
                  <li>淘宝达⼈直播运营</li>
                  <li>抖音平台直播基础知识了解</li>
                  <li>抖音平台—直播中运营</li>
                  <li>抖音平台—直播后复盘</li>
                  <li>快手平台—直播前运营</li>
                  <li>快手平台—直播中运营</li>
                </ul>
                <ul class="main_item" v-show="page ==2">
                  <li>快手直播复盘与数据分析</li>
                  <li>抖音&快手对比：抖音平台</li>
                  <li>抖音&快手对比：快手平台</li>
                  <li>什么是抖音范儿？</li>
                  <li class="red">如何做好内容选题？</li>
                  <li>短视频定位及受众分析</li>
                  <li>内容创新—用户觉察</li>
                  <li class="red">如何做好内容分析</li>
                  <li>广告植入让观众接受你的植入</li>
                  <li>短视频内容常见问题</li>
                  <li>短视频账号如何定位</li>
                  <li class="red">账号精准定位三大要素</li>
                  <li>账号冷启动的基本操作</li>
                  <li>不同行业的内容创意</li>
                  <li>视频选题</li>
                  <li class="red">线上运营不可忽视的基本操作</li>
                  <li>短视频账号常见误区</li>
                </ul>
                <el-pagination
                  class="pages"
                  background
                  :page-size="1"
                  @current-change="pageChange"
                  layout="prev, pager, next"
                  :total="2">
                </el-pagination>
              </div>
              <div class="box_r wow slideInRight" data-wow-delay="0.4s">
                <img src="@/assets/image/training/quanmeiti.png" alt="">
              </div>
            </div>
          </div>
          <div class="item_none" :class="courseActive===2?'right_show':''">
            <div class="right_box ">
              <div class="box_l">
                <p class="title"><img src="@/assets/image/training/icon_neirong.png" alt="">主要内容</p>
                <ul class="main_item">
                  <li>法律法规及行业趋势</li>
                  <li>直播间的视觉呈现</li>
                  <li>产品拍摄及预热短视频拍摄</li>
                  <li>主播个人IP打造</li>
                  <li class="red">粉丝运营转化及流量解析</li>
                  <li>直播平台规则解析</li>
                  <li>开播前准备</li>
                  <li class="red">主播间数据分析</li>
                  <li>镜头表现及发声训练</li>
                  <li>主播选品</li>
                  <li class="red">直播脚本撰写</li>
                  <li>从0到1的主播话术</li>
                  <li>主播经验心得分享</li>
                  <li>直播复盘</li>
                </ul>
              </div>
              <div class="box_r">
                <img src="@/assets/image/training/zhuangxinag.png" alt="">
              </div>
            </div>
          </div>
          <div class="item_none" :class="courseActive===3?'right_show':''">
            <div class="right_box ">
              <div class="box_l">
                <p class="title"><img src="@/assets/image/training/icon_neirong.png" alt="">主要内容</p>
                <ul class="main_item">
                  <li>淘宝店铺直播运营</li>
                  <li class="red">淘宝达⼈直播运营</li>
                  <li>抖音平台直播基础知识了解</li>
                  <li>抖音平台—直播中运营</li>
                  <li class="red">抖音平台—直播后复盘</li>
                  <li>快手平台—直播前运营</li>
                  <li>快手平台—直播中运营</li>
                  <li class="red">快手直播复盘与数据分析</li>
                </ul>
              </div>
              <div class="box_r">
                <img src="@/assets/image/training/zhuangxinag.png" alt="">
              </div>
            </div>
          </div>
          <div class="item_none" :class="courseActive===4?'right_show':''">
            <div class="right_box ">
              <div class="box_l">
                <p class="title"><img src="@/assets/image/training/icon_neirong.png" alt="">主要内容</p>
                <ul class="main_item">
                  <li>短视频生态圈</li>
                  <li>短视频如何选题定位</li>
                  <li class="red">短视频脚本创作</li>
                  <li>短视频拍摄器材与参数详解</li>
                  <li>一个好视频具备的条件</li>
                  <li class="red">短视频拍摄技巧</li>
                  <li>短视频收音</li>
                  <li class="red">短视频剪辑</li>
                  <li>短视频案例分析及实战应用</li>
                  <li>短视频发布</li>
                </ul>
              </div>
              <div class="box_r">
                <img src="@/assets/image/training/zhuangxinag.png" alt="">
              </div>
            </div>
          </div>
          <div class="item_none" :class="courseActive===5?'right_show':''">
            <div class="right_box ">
              <div class="box_l">
                <p class="title"><img src="@/assets/image/training/icon_neirong.png" alt="">主要内容</p>
                <ul class="main_item last">
                  <li>抖音平台内容解析</li>
                  <li>快手平台内容解析</li>
                  <li>如何做好内容选题？</li>
                  <li>短视频定位及受众分析</li>
                  <li class="red">内容创新—用户觉察</li>
                  <li>如何做好内容分析</li>
                  <li>广告植入让观众接受你的植入</li>
                  <li>短视频内容常见问题</li>
                  <li>短视频账号如何定位</li>
                  <li class="red">账号精准定位三大要素</li>
                  <li>账号冷启动的基本操作</li>
                  <li>不同行业的内容创意</li>
                  <li>视频选题</li>
                  <li>如何增加视频吸引力</li>
                  <li class="red">线上运营不可忽视的基本操作</li>
                  <li>dou+怎么投</li>
                  <li>短视频账号常见误区</li>
                  <li class="red">短视频发展前瞻</li>
                  <li>账号运营高阶玩法</li>
                  <li>蓝v号和蓝v矩阵号的运营建议</li>
                </ul>
              </div>
              <div class="box_r">
                <img src="@/assets/image/training/zhuangxinag.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="map">
      <div class="map_top wow bounceInDown">
        <h3>培训规模</h3>
        <p>The training scale</p>
      </div>
      <div class="content">
        <div class="left">
          <div class="top">
            <div class="item">
              <div>
                <countTo  :startVal='0' :endVal='200' :duration='3600' class="odometer">00</countTo>+
              </div>
              <p class="name">服务企业</p>
            </div>
            <div class="item">
              <div>
                <countTo :startVal='0' :endVal='300' :duration='3600'>0000</countTo>+
              </div>
              <p class="name">培训学员</p>
            </div>
            <div class="item">
              <div>
                <countTo :startVal='0' :endVal='40000' :duration='3600'>000</countTo>+
              </div>
              <p class="name">全媒体行业人才</p>
            </div>
          </div>
          <div class="bottom">
            <img class="img_l" src="../../../assets/image/training/icon_saomiao.png" alt="">
            <p class="text">数据驱动<span class="col">千万级</span>头部IP矩阵</p>
            <img class="yuan" src="../../../assets/image/training/icon_tyuan.png" alt="">
          </div>
        </div>
        <div class="right">
          <div id="echartsMap" ref="echartsMap"></div>
        </div>
      </div>
    </div>
    <div class="news">
      <div class="news_top">
        <div class="news_box wow bounceInDown">
          <h3>新媒体薪资差距正在拉大</h3>
          <p>The new media pay gap is widening</p>
        </div>
      </div>
      <div class="media">
        <div class="media_l wow slideInLeft">
          <div class="title2">培训前</div>
          <div class="info_title">
            <img src="../../../assets/image/training/fanxing_huang.png" alt="">
            <div class="title_r">
              <span>
                80%初级新媒体人月薪在4K-6K
              </span>
            </div>
          </div>
          <div class="media_info">
            <div class="info_l">
              <img src="../../../assets/image/training/icon_01px.png" alt="">
            </div>
            <div class="info_r">
              <p>内容枯竭</p>
              <p>热点每天有，10万+却总是别人的</p>
            </div>
          </div>
          <div class="media_info">
            <div class="info_l">
              <img src="../../../assets/image/training/icon_02zzfl.png" alt="">
            </div>
            <div class="info_r">
              <p>增长匮乏</p>
              <p>搞抽奖、发红包、用尽招数粉丝参与度依旧很低</p>
            </div>
          </div>
          <div class="media_info">
            <div class="info_l">
              <img src="../../../assets/image/training/icon_03bxkn.png" alt="">
            </div>
            <div class="info_r">
              <p>变现困难</p>
              <p>坚持写了大半年，终于收到1块钱打赏</p>
            </div>
          </div>
          <div class="media_info">
            <div class="info_l">
              <img src="../../../assets/image/training/icon_04zuop.png" alt="">
            </div>
            <div class="info_r">
              <p>作品播放量低</p>
              <p>上传了许多视频破不了播放，流量很低</p>
            </div>
          </div>
        </div>
        <div class="media_c ">
          <img src="../../../assets/image/training/icon_vs.png" alt="">
        </div>
        <div class="media_r wow slideInRight">
          <div class="title2">培训后</div>
          <div class="info_title">
            <img src="../../../assets/image/training/fangxing_zi.png" alt="">
            <div class="title_r">
              <span>
                20%初级新媒体人月薪12K+起
              </span>
            </div>
          </div>
          <div class="media_info">
            <div class="info_l">
              <img src="../../../assets/image/training/icon_05wdsc.png" alt="">
            </div>
            <div class="info_r">
              <p>稳定输出</p>
              <p>打造持续生产10W+的流程化内容机制</p>
            </div>
          </div>
          <div class="media_info">
            <div class="info_l">
              <img src="../../../assets/image/training/icon_06gxyl.png" alt="">
            </div>
            <div class="info_r">
              <p>高效引流</p>
              <p>打破平台便捷，使用运营技巧实现目标用户高效增长</p>
            </div>
          </div>
          <div class="media_info">
            <div class="info_l">
              <img src="../../../assets/image/training/icon_07ksbx.png" alt="">
            </div>
            <div class="info_r">
              <p>快速变现</p>
              <p>商业流程把控，为团队实现百万甚至千万营收变现</p>
            </div>
          </div>
          <div class="media_info">
            <div class="info_l">
              <img src="../../../assets/image/training/icon_08zptj.png" alt="">
            </div>
            <div class="info_r">
              <p>作品热门推荐</p>
              <p>原创作品使用方法后，经常上推荐</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="online" id="form">
      <div class="online_top  wow bounceInDown">
        <h3>国家广播电视总局广播电视和网络视听播音主持教育培训基地</h3>
        <p>全媒体人才培训计划</p>
        <div>学员报名系统</div>
      </div>
      <div class="form">
        <el-form class="formData" :model="FormData" :rules="rules" ref="FormData" >
          <el-form-item class="max_input" prop="name">
            <label for="">姓名：<span>*</span></label>
            <el-input maxlength="6" @change="isVal" v-model="FormData.name" ></el-input>
          </el-form-item>
          <el-form-item class="max_input" prop="phone">
            <label for="">电话：<span>*</span></label>
            <el-input maxlength="11" @change="isVal" v-model="FormData.phone"></el-input>
          </el-form-item>
          <el-form-item class="max_input">
            <label for="">性别：<span>*</span></label>
             <div>
               <el-radio-group v-model="FormData.sex" @change="isVal">
                <el-radio :label="1" name="sex">男</el-radio>
                <el-radio :label="2" name="sex">女</el-radio>
              </el-radio-group>
             </div>
          </el-form-item>
          <el-form-item class="max_input" prop="id_card">
            <label for="">身份证号：<span>*</span></label>
            <el-input maxlength="18" @change="isVal" v-model="FormData.id_card" ></el-input>
          </el-form-item>
          <el-form-item class="max_input" prop="address">
            <label for="">通讯地址：<span>*</span></label>
            <el-input @change="isVal" v-model="FormData.address" ></el-input>
          </el-form-item>
          <el-form-item class="max_input">
            <label for="">邮箱:</label>
            <el-input @change="isVal" v-model="FormData.email" ></el-input>
          </el-form-item>
          <el-form-item class="max_input" prop="wx_number">
            <label for="">微信号：<span>*</span></label>
            <el-input maxlength="15" @change="isVal" v-model="FormData.wx_number" ></el-input>
          </el-form-item>
          <el-form-item class="max_input" prop="course_id">
            <label for="">学习方向：<span>*</span></label>
            <div class="sel_input">
              <el-select  class="sel" @change="isVal" v-model="FormData.course_id" placeholder="请选择课程">
                <el-option
                  v-for="item in course"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                  :disabled="item.disabled">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item class="max_input">
            <label for="">获取来源：</label>
            <div class="sel_input">
              <el-select  class="sel" v-model="FormData.sourceId" placeholder="请选择课程">
                <el-option
                  v-for="item in sourceList"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item class="check">
            <el-checkbox label="我已阅读并同意" :checked="isCheck" @change="isChecked('FormData')"></el-checkbox>
            <span @click="Dailog" class="show_main">《课程报名协议》</span>
          </el-form-item>
          <el-form-item class="btn_box">
            <el-button :class="btny ? 'actbtn':'btn'"  @click="submitForm('FormData')">下一步</el-button>
          </el-form-item>
        </el-form> 
      </div>
      <el-dialog
        class="dialog_box"
        :visible.sync="isShow"
        width="800"
        center>
        <div class="dailog-cont">
          <iframe style="width: 100%;height:100%;" src="https://www.zhilu.cn/agreement/agreement.html" frameborder="0"></iframe>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import echarts from 'echarts'
import 'echarts/map/js/china.js'
import {WOW} from 'wowjs'
import countTo from 'vue-count-to';

export default {
  metaInfo() {
    return this.metaData;
  },
  components: {
    countTo 
  },
  name: '',
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  data() {
    
    var validatePhone = (rule, value, callback) => {
      const phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value === '') {
        return callback(new Error('请输入手机号码'))
      } else if (phoneReg.test(value)) {
        return callback()
      } else {
        return callback(new Error('请输入正确手机号码'))
      }
    }
    var validateIdCard = (rule, value, callback) => {
      const idCardReg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (value === '') {
        return callback(new Error('请输入身份证号码'))
      } else if (idCardReg.test(value)) {
        return callback()
      } else {
        return callback(new Error('请输入正确身份证号码'))
      }
    } 
    var validateCourse = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请选择课程'))
      } else {
        return callback()
      }
    } 
    return {
      swiperOption: {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 0,
        slidesPerGroup: 1,
        centeredSlides:true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".next",
          prevEl: ".prev"
        }
      },
      rules:{
        course_id:[
         { required: true, validator: validateCourse }
        ],
        wx_number:[
          { required: true, trigger: 'blur', message: '微信号不能为空' }
        ],
        address:[
          { required: true, trigger: 'blur', message: '地址不能为空' }
        ],
        name: [
          { required: true, trigger: 'blur', message: '姓名不能为空' }
        ],
        phone: [
          { required: true, validator: validatePhone }
        ],
        id_card: [
          { required: true, validator: validateIdCard }
        ],
      },
      courseActive:1,
      FormData:{
        phone:'',
        name:'',
        age:'',
        sex:1,
        nation:'',
        live_age:'',
        live_platform: '',
        live_company:'',
        school:'',
        address:'',
        fans_count:'',
        now_address:'',
        course_id:'',
        live_name:'',
        live_content:'',
        id_card:'',
        sourceId: 0,
        wx_number:'',
        from_invite:'',
        channel:'guanwang',
        email:''
      },
      liNum: 1,
      page:1, // fenye
      btny:false,
      isCheck:false,
      isShow: false,
      course:[], // 课程列表
      sourceList: [// 来源渠道列
        {val:"官网",id:0},
        {val:"武汉教培中心",id:1},
        {val:"南昌实训基地",id:2},
        {val:"长沙实训基地",id:3},
        {val:"沈阳实训基地",id:4},
        {val:"福州实训基地",id:5}
      ], 
      isdisabled: false,
      metaData: {
        title: "全媒体运营师培训课程_网络视听主播_短视频运营培训_泽谷传媒", // set a title
        meta: [
          {
            // set meta
            name: "keyWords",
            content: "网络视听主播培训、短视频运营培训、全媒体运营师培训",
          },
          {
            name: "description",
            content:
              "由国家广播电视总局教育培训基地主办与颁发全媒体运营师职业技能证书，提供网络视听主播证书培训、全媒体运营师培训课程、短视频运营课程。更多主播短视频实战培训尽在泽谷传媒。",
          },
        ],
      },
    };
  },
  mounted(){
     this.$nextTick(()=>{
      let wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true
    })
    wow.init()
    })
    if(this.isMobile(navigator.userAgent)){
      let url = window.location.origin.replace(/www./, "m.");
      window.location.href=url+'/page/h5/training.html'
    }
    // echarts.init('echartsMap')
    this.getMap()
    this.innitChart2()
    this.getCourse()
  },
  methods: {
    // 判断是否为移动端
    isMobile(ua) {
      return !!ua.match(/AppleWebKit.*Mobile.*/)
    },
    mouseenter(a) {
      this.liNum = a
    },
    mapMouse() {},

    // 分页
    pageChange(val) {
      this.page = val
      console.log(this.page);
    },

    innitChart2(){
      var myChart2 = echarts.init(document.getElementById('chart2'));
      let option2 = {
        grid: {
          y: 20,
          y2: 20,
          x: 0,
          x2: 0
        },
        xAxis: [
          {
            type: 'category',
            data: ['3-4.5k', '4.5-6k', '6-8k', '8-10k', '10-15k', '15-20k', '20-30k'],
            axisPointer: {
              type: 'shadow'
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            show: false,
            type: 'value',
            name: '',
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            data: [6.1, 4.3, 15.1, 14.5, {
              value: 26.7,
              itemStyle: {
                normal: {
                  color: '#7ABFFF'
                }

              }
            }, 12.8, 11.7],
            barWidth: 47,
            itemStyle: {
              normal: {
                color: '#6C8CF3',
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: { //数值样式
                    color: 'black',
                    fontSize: 14
                  },
                  formatter: "{c}%"
                }
              }
            },

          }
        ]
      };
      myChart2.setOption(option2)
    },
    // 地图
    getMap() {
      let myChart = echarts.init(this.$refs.echartsMap);
      // 省级高亮
      let province = [
        {
          name: '四川',
          label: {
            normal: {
              show: false,
              textStyle: {
                fontSize: 11,
              }
            },
            emphasis: {
              show: true,
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#ffca3a",
            }
          }
        }, {
          name: '湖南',
          label: {
            normal: {
              show: false,
              textStyle: {
                fontSize: 11,
              }
            },
            emphasis: {
              show: true,
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#ffca3a",
            }
          }
        }, {
          name: '湖北',
          label: {
            normal: {
              show: false,
              textStyle: {
                fontSize: 11,
              }
            },
            emphasis: {
              show: true,
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#ffca3a",
            }
          }
        } ,{
          name: '浙江',
          label: {
            normal: {
              show: false,
              textStyle: {
                fontSize: 11,
              }
            },
            emphasis: {
              show: true,
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#ffca3a",
            }
          }
        }, {
          name: '江西',
          label: {
            normal: {
              show: false,
              textStyle: {
                fontSize: 11,
              }
            },
            emphasis: {
              show: true,
            }
          },
          itemStyle: {
            normal: {
              areaColor: "#ffca3a",
            }
          }
        }
      ]
      // 飞线样式
      let geo = {
        "map": "china",
        "polyline": true,
        "show": true,
        "progressiveThreshold": 100,
        "progressive": 400,
        "label": {
          "emphasis": {
            "show": true
          }
        },
        "roam": false,
        "itemStyle": {
          "normal": {
            "areaColor": "rgba(0,0,0,0)", //连接线的颜色
            "borderColor": "rgba(0,0,0,0)"//移动飞线的颜色
          },
          "emphasis": {
            "areaColor": "rgba(0,0,0,0)" //
          }
        }
      }

      let coord = [
        {name:'成都',value:[104.065735,30.659462]},
        {name:'武汉',value:[113.298572,30.584355]},
        {name:'湘潭',value:[110.982279,28.19409]},
        {name:'南昌',value:[115.892151,28.676493]},
        {name:'台州',value:[120.153576,28.287459]},
      ]
      let lines_coord = [];
      coord.forEach(function(v,index) {
          index > 0 && lines_coord.push({
              coords:[coord[0].value,v.value]
          })
      })

      //使用制定的配置项和数据显示图表
      myChart.setOption({
        //提示框组件
        tooltip: {
          show: false, //是否显示组件
          trigger: 'item', //数据触发类型  item：数据图饼图触发      axis:坐标轴触发
          formatter: '{b}' //地图 {b}（区域名称）
        },
        geo:geo,
        series: [{
            name: '中国',
            type: 'map',
            mapType: 'china',
            selectedMode: 'multiple',
            itemStyle: { //有2个状态  normal 是图形在默认状态下的样式；emphasis 是图形在高亮状态下的样式
              normal: {
                label: {
                  show: true,
                  textStyle: { //标签的文本样式
                    fontSize: 18,
                    color: '#000'
                  }
                },
                areaColor: '#e1ebf5',
                borderColor: '#fff', //边框颜色
                borderWidth: 0.5, //边框线宽
                areaStyle: { //区域样式
                  color: '#000'
                }
              },
              emphasis: {
                borderWidth: 0.5,
                borderColor: '#fff',
                areaColor: '#ffca3a',
                label: {
                  shadowColor: '#000', //默认透明
                  shadowBlur: 10,
                  show: true,
                  textStyle: {
                    fontSize: 11,
                    color: '#000'
                  }
                }
              }
            },
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              }
            },
            data: province,
            markPoint: {
              show: true,
              symbol: 'circle',
              symbolSize: 10,
            }
          }, {
            type: 'effectScatter',
            // zlevel:11,
            label:{
              normal:{
                show:true,
                fontSize:12,
                color: '#2B3748',
                formatter:'{b}',
                offset:[-10,-10]
              }
            },
            coordinateSystem: 'geo',
            zlevel: 15,
            symbolSize: 5,
            rippleEffect: {
              period: 4,
              brushType: 'fill',
              scale: 4
            },
            itemStyle: {
              normal:{
                color: '#3AA9FF',
              opacity: 1
              }
            },
            data: coord.slice(1)
          },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel:11,
            label:{
              normal:{
                show:true,
                fontSize:12,
                color: '#2B3748',
                formatter:'{b}',
                offset:[-10,-10]
              }
            },
            symbolSize: 8,
            rippleEffect: {
              period: 6,
              brushType: 'stroke',
              scale: 8,
              color:'red'
            },
            itemStyle: {
              normal:{
                color: 'red',
                opacity: 1
              }
            },
            data: coord.slice(0, 1)
          },
          {
            type: 'lines',
            coordinateSystem: 'geo',
            zlevel: 15,

            effect: {
              show: true,
              period: 5,
              trailLength: 0,
              symbol: 'arrow',
              color: '#01AAED',
              symbolSize: 8,
            },
            lineStyle: {
              normal: {
                width: 1.2,
                opacity: 0.6,
                curveness: 0.2,
                color: '#3AA9FF'
              }
            },
            data: lines_coord
          }
        ]
      });
      // echarts鼠标事件
      myChart.on("mouseover", function (params){	
        if(params.data == undefined){
          myChart.dispatchAction({
                type: 'downplay'
              });
        }
      });
      myChart.on("click", function (params){	
        if(params.data == undefined){
          myChart.dispatchAction({
                type: 'downplay'
              });
        }
      });
    },
    // 课程排序
    OutpatientPrintSortByArr(list){
      return list.sort(function (a, b) {
        if (a["sort"] === b["sort"]) {
            if (a["status"] === b["status"]) {
                return 0
            } else if (a["status"] > b["status"]) {
                return 1
            } else {
                return -1
            }
        } else {
            if (a["sort"] < b["sort"]) {
                return -1;
            } else {
                return 1;
            }
        }
      });
    },
    // 获取课程
    getCourse() {
      let that = this
      that.$axios.post('/course',{}).then((res) => {
        if(res.code === 0) {
          that.course = that.OutpatientPrintSortByArr(res.data)
          that.course = that.course.filter(item=>item.status=== 0&&item.study_type!==1&&item.study_type!==2)
        //  console.log(that.course);
          that.course.forEach(e => {
            if(e.status === 2) {
              e.disabled  = true
            }
          })
          // console.log(that.course);
        }
      })
    },
    // 协议
    Dailog() {
      this.isShow = true
    },
    isChecked() {
      this.isCheck = !this.isCheck
      if(this.isCheck && this.FormData.name !== '' && this.FormData.phone !== '' && this.FormData.sex !== ''
      && this.FormData.wx_number !== '' && this.FormData.id_card !== '' && this.FormData.course_id !== '') {
        this.btny = true
      } else {
        this.btny = false
      }
    },
    isVal(){
      if(this.isCheck && this.FormData.name !== '' && this.FormData.phone !== '' && this.FormData.sex !== ''
      && this.FormData.wx_number !== '' && this.FormData.id_card !== '' && this.FormData.course_id !== '' ) {
        this.btny = true
      }
    },
    submitForm(FormData) {
      let formData = this.FormData
      this.$refs[FormData].validate((valid) =>{
        if( !this.isCheck){
         this.$message.warning("请阅读并勾选课程协议");
         return false;
        }
        if(valid) {
          window.location.href = 'https://www.zhilu.cn/pay/pay.html?'+'phone='+formData.phone+'&name='+formData.name+
            '&sex='+Number(formData.sex)+'&id_card='+formData.id_card+'&address='+formData.address+'&email='+formData.email+
            '&course_id='+Number(formData.course_id)+'&wx_number='+formData.wx_number+
            '&from_invite='+""+'&channel='+"guanwang"
        }
      })
    }
  },
  
};
</script>
<style lang="scss" >
.swpier_box {
    .prev {
      position: absolute;
      top: 90px;
      left: 0;
      z-index: 99;
    }
    .next {
      position: absolute;
      top: 90px;
      right: 0;
      z-index: 99;
    }
    .swiper-pagination {
      bottom: 0px;
    }
}
.dialog_box {
  .el-dialog--center .el-dialog__body  {
    
    padding: 0px 25px 30px;
  }
}
.base_r {
 .el-pagination.is-background .active {
   background-color:#6F62F7 !important
 }
}
</style>
<style lang="scss" scoped>
#training {
  width: 100%;
  min-width: 1200px;
  .banner {
    width: 100%;
    min-width: 1200px;
    position: relative;
    // max-height: 550px;
    img{
      width: 100%;
      max-height: 550px;
      display: block;
    }
    .bottom{
      position: absolute;
      bottom: 20%;
      left: 20%;
      display: flex;
      a{
        font-size: 20px;
        display: block;
        width: 171px;
        height: 50px;
        line-height: 50px;
        background: linear-gradient(
      -90deg
      ,#388de3,#689efe);
        border-radius: 25px;
        color: #fff;
        text-align: center;
        margin-right: 45px;
        cursor: pointer;
        text-decoration: none;
      }
    }
  }
  .skill {
    width: 100%;
    margin: 0 auto;
    background: #F5FAFF;
    padding-bottom: 25px;
    overflow: hidden;
    .skill_top {
      text-align: center;
      .skill_box{
        width: 1200px;
        margin: 50px auto 0;
      }
      h3{
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2B3748;
      }
      p{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #7D8A9C;
      }
    }
    .level {
      width: 1200px;
      margin: 20px auto;
      display: flex;
      justify-content: space-between;
      .level_box {
        cursor: pointer;
        img{
          display: block;
          width: 363px;
          height: 459px;
        }
      }
    }
    .level :hover {
        transform: scale(1.05);
        transition: all 1s;
      }
  }
  .prospect{
    width: 1200px;
    margin: 0 auto;
    text-align: left;
    > .title{
      text-align: center;
      margin-top: 77px;
      margin-bottom: 44px;
      p{
        font-size: 14px;
        font-weight: 400;
        color: #7D8A9C;
      }
      h3{
        font-size: 34px;
        font-weight: bold;
        color: #2B3748;
      }
    }
    .content >.item{
      margin-bottom: 65px;
    }
    .content  .title{
      color: #333333;
      font-size: 20px;
      margin-bottom:52px;
      text-align: left;
      .number{
        color: #6C8CF3;
        font-size: 22px;
        font-weight: bold;
      }
    }
    .center{
      display: flex;
      justify-content:space-around;
      >div{
        width: 600px;
        overflow: hidden;
      }
    }
    .right .center{
      height: 450px;
      overflow: hidden;
      p{
        color: #333333;
        font-size: 22px;
        font-weight: bold;
        text-align: center;
      }
      img{
        display: block;
        margin: 0 auto 20px;
      }
    }
    .right .bottom{
      color: #999999;
      font-size: 12px;
      text-align: center;
    }
    .item .content{
      display: flex;
      justify-content: space-around;
      padding-top: 50px;
      >.item{
        position: relative;
        padding: 80px 42px 21px;
        text-align: center;
        width: 283px;
        height: 247px;
        background: #FFFFFF;
        border: 1px solid #E2EAF0;
        border-radius: 5px;
        box-sizing: border-box;
        margin: 0;
      }
    }
    .item .item  .title1 {
      font-size: 20px;
      color: #2B3748;
      margin-bottom: 0;
    }
    .item .item>img.dell {
      display: block;
      height: 4px;
      margin: 11px auto 0;
    }
    .item .item .bottom {
      margin-top: 10px;
      color: #7D8A9C;
      font-size: 13px;
      line-height: 26px;
    }
    .content>.item>img:first-child {
      display: block;
      position: absolute;
      top: -52px;
      left: 91px;
    }
    .center> .left.cell{
      border: none;
      border-right: 1px solid #F2F2F2;
      padding-right: 50px;
      font-size: 20px;
    }
    .left .wages{
      color: #333333;
      font-size: 14px;
      margin-bottom: 18px;
    }
    .left  .blue{
      color: #428FFD;
    }
    .left .blue span{
      font-size: 28px;
      font-weight: bold;
    }
    .left .source{
      color: #999999;
      font-size: 12px;
      margin-bottom: 29px;
    }
    .left .section{
      color: #647183;
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 70px;
    }
    .left .source1{
      font-size: 13px;
      color: #808080;
      margin-top: 25px;
    }
    .center1{
      display: flex;
      justify-content: space-around;
    }
  }
  #chart2{
    width: 500px;
    height: 110px;
  }
  .courses  {
    width: 100%;
    background-color: #F5FAFF;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding-bottom: 49px;
    .courses_top {
      width: 100%;
      .courses_box{
        width: 1200px;
        text-align: center;
        margin: 50px auto 0;
      }
      h3{
        font-size: 32px;
        font-weight: bold;
        color: #2B3748;
      }
      p{
        font-size: 14px;
        font-weight: 400;
        color: #7D8A9C;
      }
    }
    .base {
      width: 1200px;
      display: flex;
      justify-content: space-between;
      .base_l {
        width: 202px;
        height: 462px;
        li{
          list-style: none;
          p{
            margin: 0;
            padding: 0;
          }
        }
        .base_top {
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          color: #FFFFFF;
          padding-top: 14px;
        }
        .title_l .title_p {
          width: 202px;
          height: 68px;
          border-radius: 8px;
          color: #2B3748;
          font-size: 18px;
          margin-bottom: 30px;
          cursor: pointer;
          text-align: center;
          line-height: 68px;
        }
        .title_l .title_p.child1{
          background: url(../../../assets/image/training/1kuang.png) no-repeat;
          background-size: 100% 100%;
        }
        .title_l .title_p.child1.title_p_y{
          color: #FFFFFF;
          background: url(../../../assets/image/training/01kuang.png) no-repeat;
          background-size: 100% 100%;
        }
        .title_l .title_p.child2{
          background: url(../../../assets/image/training/2kuang.png) no-repeat;
          background-size: 100% 100%;
        }
        .title_l .title_p.child2.title_p_y{
          color: #FFFFFF;
          background: url(../../../assets/image/training/02kuang.png) no-repeat;
          background-size: 100% 100%;
        }
        .title_l .title_p.child3{
          background: url(../../../assets/image/training/3kuang.png) no-repeat;
          background-size: 100% 100%;
        }
        .title_l .title_p.child3.title_p_y{
          color: #FFFFFF;
          background: url(../../../assets/image/training/03kuang.png) no-repeat;
          background-size: 100% 100%;
        }
        .title_l .title_p.child4{
          background: url(../../../assets/image/training/4kuang.png) no-repeat;
          background-size: 100% 100%;
        }
        .title_l .title_p.child4.title_p_y{
          color: #FFFFFF;
          background: url(../../../assets/image/training/04kuang.png) no-repeat;
          background-size: 100% 100%;
        }
        .title_l .title_p.child5{
          background: url(../../../assets/image/training/5kuang.png) no-repeat;
          background-size: 100% 100%;
        }
        .title_l .title_p.child5.title_p_y{
          color: #FFFFFF;
          background: url(../../../assets/image/training/05kuang.png) no-repeat;
          background-size: 100% 100%;
        }
      }
      .base_r {
        text-align: left;
        width: 968px;
        height: 462px;
        border: 1px solid #8E6BF3;
        box-shadow: 0px 4px 10px 0px rgba(71, 94, 220, 0.15);
        border-radius: 10px;
        background: url(../../../assets/image/training/bg_kc.png) no-repeat;
        background-position-y: bottom;
        background-size: auto;
        .item_none {
          display: none;
        }
        .right_show {
          display: block;
        }
        .right_box {
          display: flex;
          justify-content: space-between;
          padding:11px 8px 10px 16px;
          .title{
              font-size: 16px;
              font-weight: bold;
              color: #2B3748;
              text-align: left!important;
              img{
                margin-right: 10px;
              }
            }
          .box_l{
            position: relative;
            li {
              list-style: none;
              line-height: 1;
            }
            .main_item {
              width: 628px;
              font-size: 14px;
              font-weight: 400;
              color: #666666;
              line-height: 35px;
              display: flex;
              flex-wrap: wrap;
              li{
                width: 209px;
                margin-bottom: 36px;
                position: relative;
                padding-left: 10px;
                box-sizing: border-box;
                display: inline-block;
              }
              li.red{
                color: #F32E73;
              }
              li::before{
                position: absolute;
                top: 6px;
                left: 0;
                content: '';
                border-radius: 50%;
                width: 4px;
                height: 4px;
                background-color: #987AF4;
              }
              li.red::before{
                background-color: #F32E73;
              }
            }
            .box_r {
              img{
                display: block;
                width: 314px;
                height: 441px;
              }
            }
            .pages {
              position: absolute;
              bottom: 20px;
              left: 0px;
            }
          }
        }
      }
    }
  }
  .map{
    width: 1200px;
    margin: 0 auto;
    .map_top {
      text-align: center;
      margin-top: 85px;
      h3{
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2B3748;
      }
      p{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #7D8A9C;
      }
    }
    .content{
        display: flex;
        align-items: center;
        justify-content: space-around;
        background: url(../../../assets/image/training/bg_guimo.png) no-repeat;
        background-size: 900px 346px;
        background-position: -76px 120px;
      .left{
        .top{
          margin-top: 55px;
          margin-bottom: 50px;
          display: flex;
          justify-content: space-around;
          text-align: center;
          .item{
            width: 130px;
            >p {
              color: #616975;
              font-size: 14px;
            }
          }
          .item>div:first-child {
            color: #6F62F7;
            font-size: 32px;
          }
        }
        .bottom{
          width: 522px;
          height: 76px;
          background: #FFFFFF;
          box-shadow: 0px 0px 21px 0px rgba(223, 223, 223, 0.73);
          border-radius: 10px;
          position: relative;
          display: flex;
          .text{
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #616975;
            margin: 30px 0 0 30px;
          }
          .img_l{
            width: 97px;
            height: 70px;
            margin-top: 17px;
          }
          .yuan{
            width: 31px;
            height: 32px;
            position: absolute;
            bottom: -15px;
            right: -15px;
          }
        }
      }
    }
  }
  .news {
    background: url('../../../assets/image/training/bg_xinzi.png') no-repeat;
    background-size: 100% 100%;
    margin-top: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .news_box {
      width: 1200px;
      margin: 50px auto 0;
      text-align: center;
      p {
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
    .news_top {
      text-align: center;
       width: 100%;
      h3{
        font-size: 34px;
        font-weight: bold;
        color: #FFFFFF;
      }
      p{
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
    .media {
      width: 1200px;
      display: flex;
      justify-content: space-between;
      padding: 20px 0 80px 0;
      position: relative;
      margin-top: 74px;
      .media_l{
        width: 540px;
        height: 433px;
        background: #EAEDEF;
        border-radius: 13px;
        padding:70px 0  20px 39px;
        position: relative;
        box-sizing: border-box;
        .title2{
          background-color: #CBCFD2;
        }
        .info_title {
          display: flex;
          align-items: center;
          height: 40px;
          margin-bottom: 20px;
          img {
            margin-left: 13px;
          }
          .title_r {
            margin-left: 25px;
            height: 39px;
            font-size: 18px;
            font-weight: bold;
            color: #FF7862;
            line-height: 39px;
          }
        }
        .media_info {
          display: flex;
          align-items: center;
          margin-top: 20px;
          .info_r {
            margin-left: 12px;
            text-align: left;
            p {
              margin: 0;
              padding: 0;
              font-size: 14px;
              font-weight: 400;
              color: #616975;
              line-height: 24px;
            }
            p:first-child {
              font-size: 14px;
              font-weight: bold;
              color: #FF7862;
            }
          }
          
        }
      }
      .title2{
        position: absolute;
        top: -31px;
        left: 178px;
        width: 184px;
        height: 61px;
        line-height: 61px;
        color: #FFFFFF;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        border-radius: 8px;
      }
      .media_c {
        position: absolute;
        top: 120px;
        left: 50%;
        transform: translate(-50%);
        z-index: 1;
      }
      .media_r {
        box-sizing: border-box;
        width: 540px;
        height: 433px;
        background-color: #FFFFFF;
        border-radius: 13px;
        padding:70px 0  20px 39px;
        position: relative;
        .title2{
          background-color: #FFCA3A;
        }
        .info_title {
          display: flex;
          align-items: center;
          height: 40px;
          margin-bottom: 20px;
          img {
            margin-left: 13px;
          }
          .title_r {
            margin-left: 25px;
            height: 39px;
            font-size: 18px;
            font-weight: bold;
            color: #7B70F4;
            line-height: 39px;
          }
        }
        .media_info {
          display: flex;
          align-items: center;
          margin-top: 20px;
          .info_r {
            margin-left: 12px;
            text-align: left;
            p {
              margin: 0;
              padding: 0;
              font-size: 14px;
              font-weight: 400;
              color: #616975;
              line-height: 24px;
            }
            p:first-child {
              font-size: 14px;
              font-weight: bold;
              color: #7B70F4;
            }
          }
        }
      }
    }
  }
  .authority {
    margin-top: 100px;
    width: 1200px;
    background: #ffffff;
    padding: 20px;
    margin: 50px auto 0;
    .authority_top{
      text-align: center;
      h3{
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2B3748;
      }
      p{
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #7D8A9C;
      }
    }
    .swpier_box {
      width: 1200px;
      margin: 0 auto;
    }
  }
  .online {
    margin-top: 100px;
    width: 100%;
    background: #ffffff;
    .online_top{
      text-align: center;
      h3{
        font-size: 32px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 18px;
      }
      p{
        font-size: 26px;
        font-weight: 400;
        color: #2B3748;
        margin-bottom: 33px;
      }
      div{
        width: 199px;
        height: 47px;
        line-height: 46px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        background: url(../../../assets/image/training/biaoti_xitong.png) no-repeat;
        background-size: cover; 
        margin: 0 auto 47px;
      }
    }
    .form {
      width: 1200px;
      margin: 20px auto;
      .formData {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .min_input {
          width: 20%;
          text-align: left;
          margin-right: 60px;
          line-height: 30px;
          label{
            span {
              color: red;
            }
          }
        }
        .max_input {
          width: 28%;
          text-align: left;
          margin-right: 60px;
          line-height: 30px;
          label{
            span {
              color: red;
            }
          }
          .sel_input {
            width: 100%;
            .sel {
              width: 100%;
            }
          }
        }
        .check {
          width: 100%;
          .show_main{
            color: #6C8CF3;
          }
          span{
            cursor: pointer;
          }
        }
        .btn_box {
          width: 100%;
          .btn {
            width: 437px;
            height: 44px;
            background: #b9b8b8;
            border-radius: 22px;
            border: 0px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            margin: 0 auto;
          }
          .actbtn {
            width: 437px;
            height: 44px;
            background: #F7B71F;
            border-radius: 22px;
            border: 0px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
          }
        }
      }
    }
    .dialog_box {
      .dailog-cont {
        height: 600px;
        font-size: 12px;
        line-height: 25px;
      }
      // .dailog-cont::-webkit-scrollbar {
      //   width: 4px;
      //   /*height: 4px;*/
      // }
      // .dailog-cont::-webkit-scrollbar-thumb {
      //   border-radius: 10px;
      //   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      //   background: rgba(0, 0, 0, 0.2);
      // }

      // .dailog-cont::-webkit-scrollbar-track {
      //   -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      //   border-radius: 0;
      //   background: rgba(0, 0, 0, 0.1);
      // }
      // height: 600px;
      // overflow-y: auto;
    }
  }
}
#echartsMap{
  width: 723px;
  height: 500px;
}
#swiper1::-webkit-scrollbar {
  width: 5px;
  /*height: 4px;*/
}

#swiper1::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(254, 211, 85, 1);
  background:rgba(254, 211, 85, 1);
}
</style>
